"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var http_1 = require("@angular/http");
var base_1 = require("@bhtp-client-api/base");
var Rx_1 = require("rxjs/Rx");
var BhtpPackageService = (function (_super) {
    __extends(BhtpPackageService, _super);
    function BhtpPackageService(http) {
        var _this = _super.call(this) || this;
        _this.http = http;
        _this.packageCache = {};
        return _this;
    }
    BhtpPackageService.prototype.getPackageByRatingIdAndState = function (ratingId, state, quoteDate) {
        var _this = this;
        // check for cached value and return that
        if (this.packageCache[ratingId] && this.packageCache[ratingId][state]) {
            return Rx_1.Observable.of(this.packageCache[ratingId][state]);
        }
        var url = this.getFullUrl("v1/Packages/" + ratingId + "/State/" + state);
        var options = this.getStandardRequestOptions();
        this.addAuthorizationToken(options);
        if (quoteDate) {
            options.search = new http_1.URLSearchParams();
            options.search.set('quoteDate', quoteDate);
        }
        return this.http.get(url, options)
            .map(function (res) { return res.json(); })
            .do(function (val) {
            _this.packageCache[ratingId] = (_a = {}, _a[state] = val, _a);
            var _a;
        })
            .catch(this.handleError);
    };
    return BhtpPackageService;
}(base_1.BhtpBaseService));
BhtpPackageService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], BhtpPackageService);
exports.BhtpPackageService = BhtpPackageService;
//# sourceMappingURL=D:/a/1/s/purchase/src/package-service.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/purchase/src/package-service.js